// Date range presets & helpers (Spanish)
export const todayISO = () => new Date().toISOString().slice(0, 10);

const toISO = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const presets = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const lastDayOfMonth = (yy, mm) => new Date(yy, mm + 1, 0);

  const quarterStart = (mth) => Math.floor(mth / 3) * 3;

  return {
    this_month: {
      label: "Este mes",
      from: toISO(new Date(y, m, 1)),
      to: toISO(now),
    },
    last_month: {
      label: "Mes pasado",
      from: toISO(new Date(y, m - 1, 1)),
      to: toISO(lastDayOfMonth(y, m - 1)),
    },
    this_quarter: {
      label: "Este trimestre",
      from: toISO(new Date(y, quarterStart(m), 1)),
      to: toISO(now),
    },
    last_quarter: {
      label: "Trimestre pasado",
      from: toISO(new Date(y, quarterStart(m) - 3, 1)),
      to: toISO(lastDayOfMonth(y, quarterStart(m) - 1)),
    },
    ytd: {
      label: "Año en curso (YTD)",
      from: `${y}-01-01`,
      to: toISO(now),
    },
    last_year: {
      label: "Año pasado",
      from: `${y - 1}-01-01`,
      to: `${y - 1}-12-31`,
    },
  };
};

export const formatCurrency = (n, currency = "EUR") => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(n);
};

export const formatNumber = (n, opts = {}) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 2, ...opts }).format(n);
};

export const formatHours = (n) => `${formatNumber(n, { maximumFractionDigits: 1 })} h`;

export const formatPct = (n) => `${formatNumber(n, { maximumFractionDigits: 1 })}%`;

export const formatMonthLabel = (ym) => {
  // "2026-04" -> "abr 2026"
  if (!ym || !ym.includes("-")) return ym;
  const [y, m] = ym.split("-");
  const d = new Date(parseInt(y), parseInt(m) - 1, 1);
  return d.toLocaleDateString("es-ES", { month: "short", year: "2-digit" });
};
